/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { withStyles } from "@material-ui/styles";
// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import Sidebar from "components/Sidebar/Sidebar.jsx";

import dashboardRoutes from "routes/dashboard.jsx";

import dashboardStyle from "assets/jss/material-dashboard-react/layouts/dashboardStyle.jsx";

import image from "assets/img/sidebar-6.jpg";
import logo from "assets/img/reactlogo.png";
import {bindActionCreators} from "redux";
import * as actionCreators from "actions/auth";
import {connect} from "react-redux";

function mapStateToProps(state) {
    return {
        role: state.auth.role,
        isMasterOrganization: state.auth.isMasterOrganization,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch)
}

class App extends React.Component {
  state = {
    mobileOpen: false
  };
  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };
  getRoute() {
    return this.props.location.pathname !== "/maps";
  }
  filterRoute(route) {
    if (route.redirect) {
      return route
    }
    if (route.availableWithMasterOrganization === true && this.props.isMasterOrganization !== true) {
      return null;
    }
    if (route.availableWithRoles[0] === "*" || route.availableWithRoles.indexOf(this.props.role) !== -1) {
      return route
    } else {
      return null;
    }
  }
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      const ps = new PerfectScrollbar(this.refs.mainPanel);
    }
  }
  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      this.refs.mainPanel.scrollTop = 0;
      if(this.state.mobileOpen){
        this.setState({mobileOpen: false});
      }
    }
  }
  render() {
    const { classes, ...rest } = this.props;
    return (
      <div className={classes.wrapper}>
        <Sidebar
          routes={dashboardRoutes.map(prop => (this.filterRoute(prop))).filter(e => e)}
          logoText={"ГК \"ПИ\""}
          logo={logo}
          image={image}
          handleDrawerToggle={this.handleDrawerToggle}
          open={this.state.mobileOpen}
          color="blue"
          {...rest}
        />
        <div className={classes.mainPanel} ref="mainPanel">
          <Header
            routes={dashboardRoutes}
            handleDrawerToggle={this.handleDrawerToggle}
            {...rest}
          />
          {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
          <div className={classes.content}>
              <div className={classes.container}>
                  <Switch>
                      {dashboardRoutes.map((prop, key) => {
                          if (prop.redirect)
                              return <Redirect from={prop.path} to={prop.to} key={key} />;
                          return prop.availableWithRoles[0] === "*" || prop.availableWithRoles.indexOf(this.props.role) !== -1 ?
                              <Route path={prop.path} component={prop.component} key={key} exact={!!prop.exact}/>:
                              null;
                      }).filter(e => e)}
                  </Switch>
              </div>
          </div>
          {this.getRoute() ? <Footer /> : null}
        </div>
      </div>
    );
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(dashboardStyle)(App));



// WEBPACK FOOTER //
// ./src/layouts/Dashboard/Dashboard.jsx